/* AM-BUNDLE-COPY — textos y controles, IGUALES a los de Kaching.
   Se carga DESPUES de am-bundle.js y ajusta lo que este genera.

   CRITERIO (decision de Rome): Kaching le da buenos resultados a la
   tienda; lo caro es la suscripcion, no el diseno. Asi que NO se rebusca
   nada: se replica su base tal cual y las mejoras van encima.

   Los textos son LITERALES de la config real de Kaching de esta tienda,
   extraida del HTML de produccion:
     qty 1: "1 Unidad"    / "Precio Sin Descuento"       / sin cinta
     qty 2: "2 Unidades"  / "+ Envio Gratis!"            / "Con Envio Gratis!"
     qty 3: "3 Unidades"  / "(10,000 ARS OFF) + Envio Gratis" / "Envio Gratis + 10.000ARS OFF!"
     qty 4: "4 Unidades"  / "(20,000 ARS OFF) + Envio Gratis" / "Envio Gratis + 20.000ARS OFF!"

   OJO: en este widget la promesa de envio gratis se comunica por CANTIDAD,
   igual que la regla comercial de la tienda: desde 2 unidades. Esto tambien
   permite revisar el BORRADOR 7 mientras los precios Winter siguen activos:
   el pack de 2 puede verse en $69.900 antes del rollback, pero no debe perder
   ni la cinta ni el subtitulo de envio gratis.

   CADA OFERTA muestra tambien la cantidad de cuotas, sin importe por cuota.
   Minimos Mercado Pago: $39.950 = 3, $79.900 = 6, $139.000 = 9. */
(function(){
  var root = document.querySelector('[data-am-bundle]');
  if(!root) return;

  // Textos literales de la config de Kaching de esta tienda
  var SUB = {
    1: 'Precio sin descuento',
    2: 'Envío gratis',
    3: 'Envío gratis',
    4: 'Envío gratis'
  };
  var CINTA = {
    2: 'Con Envío Gratis!',
    3: 'Envío Gratis + 10.000ARS OFF!',
    4: 'Envío Gratis + 20.000ARS OFF!'
  };

  function num(txt){
    return parseInt(String(txt).replace(/[^0-9]/g, ''), 10) || 0;
  }
  function installmentsFor(pesos){
    if(pesos >= 139000) return 9;
    if(pesos >= 79900) return 6;
    if(pesos >= 39950) return 3;
    return 0;
  }

  // Recorta la promesa de envio del PROPIO texto de Kaching: se va el
  // fragmento y el conector que queda suelto, sin inventar palabras nuevas.
  //   '+ Envío Gratis!'                 -> ''
  //   '(10,000 ARS OFF) + Envío Gratis' -> '(10,000 ARS OFF)'
  //   'Con Envío Gratis!'               -> ''
  //   'Envío Gratis + 10.000ARS OFF!'   -> '10.000ARS OFF!'
  // 'Precio Sin Descuento' no tiene el fragmento y vuelve intacto.
  function sinEnvio(txt){
    return String(txt).replace(/\s*(?:\+|Con)?\s*Env[ií]o\s+Gratis!?\s*\+?\s*/i, ' ').trim();
  }

  function repintar(){
    root.querySelectorAll('[data-am-tier]').forEach(function(tier){
      var qty = parseInt(tier.dataset.qty, 10);
      var tot = num(tier.querySelector('[data-am-total]').textContent);
      var cuotas = installmentsFor(tot);

      // Regla canonica: el beneficio corresponde a cualquier pack de 2+.
      // No se ata al total visible porque el borrador post-sale se revisa
      // mientras los precios Winter todavia pueden seguir activos.
      var llega = qty >= 2;

      var sub = tier.querySelector('[data-am-sub]');
      if(SUB[qty]){
        var oferta = llega ? SUB[qty] : sinEnvio(SUB[qty]);
        var financiacion = cuotas ? cuotas + ' cuotas sin interés' : '';
        sub.textContent = '';

        var ofertaLine = document.createElement('span');
        ofertaLine.className = 'am-tier__sub-offer';
        ofertaLine.textContent = oferta;
        sub.appendChild(ofertaLine);

        if(financiacion){
          var cuotasLine = document.createElement('span');
          cuotasLine.className = 'am-tier__sub-installments';
          cuotasLine.textContent = financiacion;
          sub.appendChild(cuotasLine);
        }
      }

      var ribbon = tier.querySelector('[data-am-ribbon]');
      var cinta = CINTA[qty] ? (llega ? CINTA[qty] : sinEnvio(CINTA[qty])) : '';
      if(cinta){
        ribbon.textContent = cinta;
        ribbon.hidden = false;
      } else {
        ribbon.hidden = true;
      }

      /* El renglon "Cada mate te queda en $X" se saco de todos los tramos
         por decision de Rome (2026-08-04). Kaching tampoco lo muestra; era
         la unica "mejora" que se le habia sumado encima al bloque de packs
         y el dueño la saco para dejarlo mas limpio.
         Se sigue ocultando el elemento en vez de borrarlo del snippet para
         que este archivo no dependa de que exista: si alguien lo vuelve a
         agregar al Liquid, no reaparece solo. */
      var hl = tier.querySelector('[data-am-perks]');
      if(hl) hl.hidden = true;
    });
  }

  repintar();

  // EN FASE DE CAPTURA, no en burbuja.
  //
  // El boton "Poner los N iguales al primero" corta la propagacion con
  // stopPropagation() para que el click no se lea como "elegir este pack".
  // Con listeners en burbuja, este repintado nunca se enteraba de ese
  // click: el total se actualizaba pero el precio por unidad quedaba en el
  // valor anterior. Se veia total $124.848 y al lado "Cada mate te queda
  // en $38.283", cuando el real era $41.616 — y solo en el Acero, que es
  // el que tiene dos capacidades con precios distintos y el que mas vende.
  //
  // La captura corre ANTES del handler que frena, asi que llega siempre.
  root.addEventListener('click', function(){ setTimeout(repintar, 0); }, true);
  root.addEventListener('change', function(){ setTimeout(repintar, 0); }, true);
})();
